import { useEffect, useState } from 'react';

const BackToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 700);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      aria-label="Go to top"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-28 right-5 z-40 rounded-full bg-[#FF6F00] px-4 py-3 text-sm font-bold text-white shadow-2xl transition hover:-translate-y-1 hover:bg-[#E65F00] sm:bottom-32 sm:right-8"
    >
      Top
    </button>
  );
};

export default BackToTopButton;
